/**
 * Member-facing copy for the Mission screens (Mission Evolution v26.3).
 * "Evolved" wording only — never "updated", "old", "outdated" or
 * "superseded" — and never a version number.
 */

export const MISSION_SCREEN_COPY = {
  title: "Your Mission",
  subtitle: "The life you're intentionally working to build.",
  close: "Close",
  loading: "Loading your Mission…",
  error: "We couldn't load your Mission just now.",
  retry: "Try again",
  evolve: "Evolve My Mission",
  evolveHint: "Reflect on what has changed and evolve your Mission with Aris.",
  continueEvolving: "Continue Evolving My Mission",
  stopEvolving: "Stop evolving",
  historyTitle: "Mission History",
  historySub: "See how your Mission evolved over time.",
  pendingBody: "Your evolved Mission is ready. Nothing changes until you save it.",
  pendingCta: "Review your Mission",
  resumeHint: "Pick up where you left off with Aris.",
};

export const EVOLVE_COPY = {
  title: "Evolve your Mission",
  heroTitle: "Your mission can evolve as your life evolves.",
  heroBody:
    "Life brings new experiences, relationships, challenges, and opportunities. We can revisit your mission together to reflect what matters most to you now.",
  question: "How would you like to proceed?",
  voice: "Continue with Voice",
  voiceHint: "Talk it through with Aris",
  text: "Continue with Text",
  textHint: "Have a written conversation",
  expectTitle: "What to expect",
  expectBody:
    "This will follow the same guided Mission experience you had when you first created your mission—focused on what's changed for you now. It usually takes about 5–10 minutes.",
  startError: "We couldn't start this just now. Please try again in a moment.",
  noMission:
    "You don't have a Mission yet. Your Mission is shaped in your first conversation with Aris.",
};

export const HISTORY_COPY = {
  title: "Mission History",
  subtitle: "Your journey. Your growth.",
  infoTitle: "Your Mission Journey",
  infoBody:
    "Each evolution reflects a meaningful moment in your life. Tap any Mission to see it, and its four elements, as they were at that time.",
  loading: "Loading your Mission History…",
  error: "We couldn't load your Mission History just now.",
  retry: "Try again",
  empty: "Your Mission History will appear here once your Mission evolves.",
  detailError: "We couldn't load this Mission just now.",
  elementsTitle: "The four elements",
};

export const REVIEW_COPY = {
  title: "Your Evolved Mission",
  lead: "Here's how your Mission has evolved. Nothing changes until you save it.",
  statementLabel: "Mission Statement",
  evolvedChip: "Evolved",
  save: "Save as My New Mission",
  saving: "Saving…",
  reviewChanges: "Review Changes",
  hideChanges: "Hide Changes",
  keepCurrent: "Keep Current Mission",
  changesTitle: "What evolved",
  before: "Before",
  now: "Now",
  saved: "Your Mission has evolved",
  kept: "Your Mission stays as it is.",
  loading: "Loading your evolved Mission…",
  loadError: "We couldn't load your evolved Mission just now.",
  saveError: "We couldn't save your Mission just now. Your Mission is unchanged — please try again.",
  discardError: "Something went wrong. Please try again.",
  alreadyEvolved: "Your Mission already evolved on another device.",
  alreadyDecided: "This evolved Mission was already decided.",
  backToMission: "Back to My Mission",
  retry: "Try again",
};
